import { JSX, useEffect } from "react";
import { useSubscription } from "@apollo/client";
import { AgendaPost, OnCreateAgendaPostByCompanyIdSubscription, OnCreateAgendaPostByCompanyIdSubscriptionVariables } from "../../../graphql/API";
import { onCreateAgendaPostByCompanyId } from "../queries";

const SubscriptionComPostWrapper = ({ comId, onNewPost, subscriptionKey, onError }: {
    comId: string;
    onNewPost: (post: AgendaPost) => void;
    subscriptionKey: number;
    onError?: () => void;
  }): JSX.Element | null => {
    const { data, error } = useSubscription<
      OnCreateAgendaPostByCompanyIdSubscription,
      OnCreateAgendaPostByCompanyIdSubscriptionVariables
      >(onCreateAgendaPostByCompanyId, {
        variables: { comId, 
          filter: {
            room: {eq: comId+"_posts"}
        }},
        skip: !comId,
    });
  
    useEffect(() => {
      // if (data?.onCreateAgendaPostByCompanyId) {
      //   onNewPost(data.onCreateAgendaPostByCompanyId as AgendaPost);
      // }
      const post = data?.onCreateAgendaPostByCompanyId;
      if (post?.room === comId + "_posts") {
        onNewPost(post as AgendaPost);
      }
    }, [data]);
  
    useEffect(() => {
        if (error) {
          console.error("Subscription error");//:", error);
          onError?.();
        }
      }, [error]);
  
    return null;
  };
 export default SubscriptionComPostWrapper  